import React from 'react';

const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { container: "h-8", img: "h-8" },
    default: { container: "h-14", img: "h-14" },
    large: { container: "h-16", img: "h-16" }
  };

  return (
    <div className={`flex items-center ${className}`}>
      {/* Company logo from CDR file */}
      <img 
        src="/nanorbital-logo.png" 
        alt="Nanorbital Advanced Materials Logo" 
        className={`${sizes[size].img} w-auto object-contain`}
      />
    </div>
  );
};

export default Logo;
